import React from "react";

const RscLogo = ({
  width = "40",
  height = "24",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_336_1464)">
      <path
        d="M31.3804 3.40012L33.4787 3.40751C34.3899 3.40751 35.1607 3.68334 35.7887 4.23745C36.4167 4.78911 36.7221 5.46883 36.7049 6.27169C36.6876 7.07454 36.3699 7.74934 35.7518 8.29607C35.1336 8.8428 34.3677 9.1137 33.454 9.1137H31.3804V11.9877H33.454C34.3652 11.9877 35.1312 12.2636 35.7518 12.8128C36.3699 13.3644 36.6802 14.0392 36.6802 14.8396L36.7049 23.2031H40.0025V14.8445C40.0025 13.1304 39.2686 11.7021 37.8032 10.5593C39.2686 9.41662 40.0025 7.98822 40.0025 6.27415C40.0025 4.56008 39.372 3.31885 38.1086 2.20569C36.8452 1.09006 35.3011 0.533478 33.4762 0.533478L31.3779 0.543329V3.40012H31.3804Z"
        fill={color}
      />
      <path
        d="M28.2872 14.1919H28.2773V0.543356L24.9551 0.540894H22.911L22.9356 3.37552H24.96L24.9748 14.187L2.83463 14.1722V12.1478L0 12.1232V14.1673L0.00246275 17.4895H24.9797V17.4994H28.2773V17.4895H28.2872V14.1919Z"
        fill={color}
      />
      <path
        d="M3.5983 23.4445C4.80066 23.4445 5.77537 22.4698 5.77537 21.2674C5.77537 20.0651 4.80066 19.0904 3.5983 19.0904C2.39594 19.0904 1.42123 20.0651 1.42123 21.2674C1.42123 22.4698 2.39594 23.4445 3.5983 23.4445Z"
        fill={color}
      />
      <path
        d="M26.1003 23.4667C27.3026 23.4667 28.2773 22.492 28.2773 21.2896C28.2773 20.0872 27.3026 19.1125 26.1003 19.1125C24.8979 19.1125 23.9232 20.0872 23.9232 21.2896C23.9232 22.492 24.8979 23.4667 26.1003 23.4667Z"
        fill={color}
      />
      <path
        d="M15.8873 7.56223H11.1589V12.2907H15.8873V7.56223Z"
        fill={color}
      />
      <path
        d="M9.31182 7.56223H4.58334V12.2907H9.31182V7.56223Z"
        fill={color}
      />
      <path
        d="M12.9196 0.974335H8.19108V5.70282H12.9196V0.974335Z"
        fill={color}
      />
      <path
        d="M19.5813 0.986603H14.8529V5.71508H19.5813V0.986603Z"
        fill={color}
      />
      <path
        d="M22.4629 7.56223H17.7344V12.2907H22.4629V7.56223Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_336_1464">
        <rect
          width="40"
          height="22.9331"
          fill="white"
          transform="translate(0 0.533447)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default RscLogo;
